import React, { useState } from "react";
import Ideadox from "../logos/Ideadox.svg";
import { Typography, Tabs, Tab, Box } from "@mui/material";
import Star6 from "../logos/Star 6.svg";
import Star7 from "../logos/Star 7.svg";
import Bulb from "../logos/Bulb.svg";
import Star from "../logos/Star.svg";
import CaseStudyCard from "./CaseStudyCard";
import Card1 from "../images/Card1.svg";
import Card2 from "../images/Card2.svg";
import Card3 from "../images/Card3.svg";
import Card4 from "../images/Card4.svg";
import Card5 from "../images/Card5.svg";
import Card6 from "../images/Card6.svg";
import Card7 from "../images/Card7.svg";
import Card8 from "../images/Card8.svg";
import Card9 from "../images/Card9.svg";
import Card10 from "../images/Card10.svg";
import Card11 from "../images/Card11.svg";
import Card12 from "../images/Card12.svg";
import Linkedin from "../logos/Linkedin.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";

export const caseStudies = [
  {
    title: "Streamlining Technical Operations for Efficiency",
    link: "/case-study1",
    image: Card1,
  },
  {
    title: "Modernizing Development Practices for Enhanced Product Quality",
    link: "/case-study2",
    image: Card2,
  },
  {
    title:
      "Architecting a Scalable and Stable Product for a Non-Technical Founder",
    link: "/case-study3",
    image: Card3,
  },
  {
    title: "Ensuring Data Security and Compliance with Industry Standards",
    link: "/case-study4",
    image: Card4,
  },
  {
    title: "Transforming E-commerce User Experience for Higher Conversions",
    link: "/case-study5",
    image: Card5,
  },
  {
    title:
      "Enabling Seamless Scalability with a Transition to Microservices Architecture",
    link: "/case-study6",
    image: Card6,
  },
];

export const caseStudies2 = [
  {
    title: "Crafting a User-Centric Product Roadmap for Non-Technical Founders",
    link: "/case-study7",
    image: Card7,
  },
  {
    title: "Aligning Product Strategy with Business Goals",
    link: "/case-study8",
    image: Card8,
  },
  {
    title:
      "Improving Product Consistency and Quality with a Structured Approach",
    link: "/case-study9",
    image: Card9,
  },
  {
    title:
      "Ensuring High-Traffic Stability Through User-Centric Feature Planning",
    link: "/case-study10",
    image: Card10,
  },
  {
    title:
      "Building a Secure and Compliant Product Aligned with User Expectations",
    link: "/case-study11",
    image: Card11,
  },
  {
    title: "Optimizing User Experience for Higher E-Commerce Conversions",
    link: "/case-study12",
    image: Card12,
  },
];

const CaseStudy = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div
        className="h-screen flex flex-col justify-center items-center text-center"
        style={{
          background: "linear-gradient(to bottom, #F0DFD8, #DAAC99)",
        }}
      >
        <header
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: "1rem",
            boxSizing: "border-box",
            top: 5,
            position: "absolute",
          }}
        >
          <div>
            <img src={Ideadox} alt="Ideadox"></img>
          </div>
          {isMobile ? (
            <div>
              <Button
                className="border border-black mt-2 rounded-full"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                    boxShadow: "none",
                  },
                }}
              >
                <MenuItem
                  onClick={handleMenuClose}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  Blog
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/caseStudy")}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  Case Study
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/aboutus")}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  About
                </MenuItem>
              </Menu>
              <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
                Get In Touch
              </button>
            </div>
          ) : (
            <nav className="space-x-4 mr-4">
              <button
                className="hover:underline"
                onClick={() => {
                  /* handle click */
                }}
              >
                Blog
              </button>
              <button
                className="hover:underline"
                onClick={() => {
                  navigate("/caseStudy");
                }}
              >
                Case Study
              </button>
              <button
                className="hover:underline"
                onClick={() => navigate("/aboutus")}
              >
                About
              </button>
              <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
                Get In Touch
              </button>
            </nav>
          )}
        </header>

        <div
          className="flex flex-col items-center mb-14 relative"
          style={{ height: "400px" }}
        >
          <div className="absolute inset-0 flex justify-center items-center">
            <img
              src={Bulb}
              alt="Bulb"
              style={{
                opacity: 0.1,
                width: "70%",
                height: "auto",
                pointerEvents: "none",
                marginTop: "60px",
                marginRight: "20px",
              }}
            />
          </div>
          <Typography
            style={{
              fontFamily: "Bricolage Grotesque",
              fontWeight: 600,
              fontSize: isMobile ? "45px" : "55px",
              textAlign: "center",
              lineHeight: isMobile ? "58px" : "78px",
              letterSpacing: "0.5%",
              background:
                "linear-gradient(76.86deg, #2F2F30 18.47%, #565656 74.52%, #707070 82.94%, #9C9CA9 89.41%, #6F6F6F 119.74%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginRight: isMobile ? "1%" : "5%",
            }}
          >
            Transforming <br />
            Challenges into <br />
            Innovative Solutions
          </Typography>
          <div className="flex items-center mt-6">
            {!isMobile && (
              <div style={{ position: "relative" }}>
                <img
                  src={Star6}
                  alt="Star 6"
                  style={{
                    marginRight: "20px",
                    opacity: 5.5,
                    transform: "translateX(-70px)",
                  }}
                />
              </div>
            )}
            <Typography
              style={{
                fontWeight: 600,
                fontSize: "25px",
                fontFamily: "Bricolage Grotesque",
                color: "#78787A",
                textAlign: "center",
                marginTop: "0.1rem",
              }}
            >
              Explore how ideadox tackles real-world problems <br /> faced by
              CTOs and CPOs, delivering impactful
              <br /> results through strategic expertise.
            </Typography>
            {!isMobile && (
              <div style={{ position: "relative" }}>
                <img
                  src={Star7}
                  alt="Star 7"
                  style={{
                    marginLeft: "20px",
                    opacity: 0.7,
                    transform: "translateX(70px)",
                  }}
                />
              </div>
            )}
          </div>
          <button
            className={`px-4 py-2 bg-black text-white rounded-full hover:bg-gray-800 shadow-lg ${
              isMobile ? "mt-4" : "mt-1"
            }`}
          >
            Explore Case Studies
          </button>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#F0DFD8",
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <img
            src={Star}
            alt="Star"
            style={{ marginLeft: isMobile ? "0.2rem" : "0.6rem" }}
          />
          <Typography
            style={{
              fontSize: isMobile ? 20 : 28,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 300,
              color: "#2F2F30",
              marginLeft: isMobile ? "9px" : "12px",
            }}
          >
            Challenges - innovation
          </Typography>
        </div>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "30px" : "40px",
            textAlign: "center",
            marginTop: "20px",
            color: "#2F2F30",
          }}
        >
          Discover the Challenges We’ve Overcome
        </Typography>
        <Box
          sx={{
            width: "100%",
            borderBottom: 1,
            borderColor: "divider",
            mt: 5,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            centered
            TabIndicatorProps={{
              style: {
                backgroundColor: "#FFA500", // Orange line
              },
            }}
            sx={{
              "& .MuiTab-root": {
                color: "#2F2F30", // Default text color
                fontFamily: "Golos Text",
                fontWeight: 400,
                fontSize: isMobile ? "15px" : "20px",
              },
              "& .Mui-selected": {
                fontWeight: 600, // Highlight selected tab with bold text
              },
            }}
          >
            <Tab label="CTO Challenges" />
            <Tab label="CPO Challenges" />
          </Tabs>
        </Box>
        {value === 0 && (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              mt: 4,
            }}
          >
            {caseStudies.map((study, index) => (
              <CaseStudyCard
                key={index}
                title={study.title}
                link={study.link}
                image={study.image}
              />
            ))}
          </Box>
        )}
        {value === 1 && (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              mt: 4,
            }}
          >
            {caseStudies2.map((study, index) => (
              <CaseStudyCard
                key={index}
                title={study.title}
                link={study.link}
                image={study.image}
              />
            ))}
          </Box>
        )}
        <footer
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            marginTop: isMobile ? 0 : 5,
            padding: isMobile ? "1rem" : "0.5rem",
          }}
        >
          <div
            className="flex flex-col md:flex-row items-center"
            style={{ gap: isMobile ? "1rem" : "2rem" }}
          >
            <img
              src={Ideadox}
              alt="Ideadox"
              className="mb-4 md:mb-0"
              style={{ width: isMobile ? "120px" : "auto" }}
            />
            <div
              className="flex justify-center"
              style={{
                gap: isMobile ? "1rem" : "2rem",
                marginLeft: isMobile ? "0" : "24rem",
              }}
            >
              <button
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 600,
                  fontSize: "20px",
                }}
              >
                Blog
              </button>
              <button
                onClick={() => {
                  navigate("/caseStudy");
                }}
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 600,
                  fontSize: "20px",
                }}
              >
                Case Study
              </button>
              <button
                onClick={() => {
                  navigate("/aboutus");
                }}
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 600,
                  fontSize: "20px",
                }}
              >
                About
              </button>
            </div>
          </div>
          <div
            className="flex items-center justify-center"
            style={{
              gap: isMobile ? "1rem" : "2rem",
              marginTop: isMobile ? "1rem" : "0",
            }}
          >
            <button
              className="text-black"
              style={{
                fontFamily: "Golos Text",
                fontSize: isMobile ? "15px" : "17px",
              }}
            >
              Contact us
            </button>
            <img
              src={Linkedin}
              alt="LinkedIn"
              className="w-10 h-10"
              style={{ width: isMobile ? "30px" : "40px", fontWeight: "600" }}
            />
          </div>
        </footer>
      </div>
    </>
  );
};

export default CaseStudy;
